import { Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './pages/HomePage';
import SignupWizardPage from './pages/signup/SignupWizardPage';
import VerificaEmailPage from './pages/signup/VerificaEmailPage';
import TerminiServizioPage from './pages/legal/TerminiServizioPage';
import PrivacyPolicyPage from './pages/legal/PrivacyPolicyPage';

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/iscriviti" element={<SignupWizardPage />} />
      <Route path="/iscriviti/verifica-email" element={<VerificaEmailPage />} />
      <Route path="/termini" element={<TerminiServizioPage />} />
      <Route path="/privacy" element={<PrivacyPolicyPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default App;
